import { Link } from 'react-router-dom'
import { IconBudget, IconConnected } from "../../assets/icons";
import { formatCurrency } from "../../utilities/general-utils";
import styles from "./AccountPreview.module.css";

const OBAccountPreview = ({ account, disableLink = false, addBorder = false }) => {
    return (
        <div className={`${styles.accountPreviewWrap} ${account.includeBalance ? `${styles.balanceIncluded} bg-light-green` : ''} ${addBorder ? styles.addBorder : ''}`}>
            {disableLink ? (
                <div className={`${styles.accountPreview}`}>
                    <AccountContent account={account} />
                </div>
            ) : (
                <Link to={`/account-connected/${account.id}`} className={`${styles.accountPreview}`}>
                    <AccountContent account={account} />
                </Link>
            )}
        </div>
    )
}

export default OBAccountPreview


const AccountContent = ({ account }) => {
    return (
        <>
            <div className={styles.accountPreviewCenter}>
                <h3 className={styles.accountPreviewTitle}>
                    {account.data.name}

                    <div className={styles.accountPreviewIcons}>
                        <div className={styles.accountPreviewIcon} title="Automatic updates"><IconConnected fill="#3366cc" /></div>
                        {account.includeBalance ? <div className={styles.accountPreviewIcon} title="Included in budget"><IconBudget /></div> : ""}
                    </div>
                </h3>

                <h4 className={styles.accountPreviewInstitution}>
                    InstitutionId: {account.data.institutionId ?? null}
                </h4>
            </div>

            <div className={styles.accountPreviewRight}>
                <div className={styles.accountPreviewBalance}>
                    {formatCurrency(account.data.balance)}
                </div>
            </div>
        </>
    )
}
